<template>
    <PopupRouterView :showLeftIcon="true" label="Subcontract Request Delivery Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="subcontractrequestdelivery"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="subcontractRequestDeliveryInput">


        <b-card header="Request Delivery" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Request Delivery Number" :model="model.requestDeliveryNumber" />
					<app-input-combobox-autocomplete :options="purchaseOrders" optionsLabel="purchaseOrderNumber" optionsKey="id" label-cols-lg="12" label="Purchase Order" id="fieldset-purchase-order" size="sm" :model.sync="model.purchaseOrderId"   :selected="model.purchaseOrder != null ? model.purchaseOrder.purchaseOrderNumber : ''" @input="getPurchaseOrders" @change="updateData" :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedPurchaseOrder" />
					<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Vendor Subcontract" id="fieldset-vendor" size="sm" :model.sync="model.vendorId"   :selected="model.vendor != null ? model.vendor.code : ''" @input="getVendors" @change="updateData" :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedVendor" />
					<!-- <app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Document Status" id="fieldset-document-status" size="sm" :model.sync="model.documentStatusId"   :selected="model.documentStatus != null ? model.documentStatus.name : ''" @input="getDocumentStatuss" @change="updateData" :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedDocumentStatus" /> -->
				</b-col>
				<b-col cols="12" lg="6">
					<app-input-datepicker  id="fieldset-delivery-date" label-cols-lg="12"  label="Delivery Date" size="sm" :model.sync="model.deliveryDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isUpdatable ="null"/>
					<app-input-textarea id="fieldset-remarks" label-cols-lg="12"  label="Remarks" label-for="input-remarks" size="sm" :model.sync="model.remarks"  @change="updateData" :isUpdatable ="null"/>
				</b-col>
            </b-row>
        </b-card>

		<app-table-input 
			title = "List Part"
			:bordered="true" :items="subcontractRequestDeliveryDetails" 
			:fields="fieldsSubcontractRequestDeliveryDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortBySubcontractRequestDeliveryDetail" 
			:sort-desc.sync="sortDescSubcontractRequestDeliveryDetail" small responsive	
			@editButtonMethod="editRowDataSubcontractRequestDeliveryDetail"	
			@deleteButtonMethod="deleteRowDataSubcontractRequestDeliveryDetail"	
			@showPopupAddMethod="addDataSubcontractRequestDeliveryDetail()"	
			@showPopupUploadMethod="showPopupUploadSubcontractRequestDeliveryDetail()"
			@downloadMethod="downloadSubcontractRequestDeliveryDetail()"
			@addFromClipboardMethod="addFromClipboardSubcontractRequestDeliveryDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardSubcontractRequestDeliveryDetail()"
			:showActionButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="false"	
			:showDownloadButton="false"	
			:isDownloadBusy="isDownloadSubcontractRequestDeliveryDetail"
		>		
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( subcontractRequestDeliveryDetailPageSize * (currentSubcontractRequestDeliveryDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-subcontract-request-delivery-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"  @change="saveInputSubcontractRequestDeliveryDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isUpdatable ="false" :isEditable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(partName)="row">
				<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
			</template>
			<template v-slot:cell(poQtyOutstanding)="row">
				<app-input-textbox :id="'input-subcontract-request-delivery-detail-po-qty-outstanding-' + row.index" label-cols-lg="12" label="Qty Outstanding PO" size="sm" :model.sync="row.item.poQtyOutstanding"   @change="saveInputSubcontractRequestDeliveryDetail(row.item)" :isUpdatable ="false" :isEditable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(stockVendor)="row">
				<app-input-textbox :id="'input-subcontract-request-delivery-detail-stock-vendor-' + row.index" label-cols-lg="12" label="Stock Vendor" size="sm" :model.sync="row.item.stockVendor"   @change="saveInputSubcontractRequestDeliveryDetail(row.item)" :isUpdatable ="false" :isEditable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(deliveryQty)="row">
				<app-input-textbox :id="'input-subcontract-request-delivery-detail-delivery-qty-' + row.index" label-cols-lg="12" label="Delivery Qty" size="sm" :model.sync="row.item.deliveryQty"   @change="saveInputSubcontractRequestDeliveryDetail(row.item)" :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(uom)="row">
				<app-label label-cols-lg="12" size="sm" label="Uom" :model="(row.item.part != null) ? (row.item.part.uom != null) ? row.item.part.uom.code : null : null"  />
			</template>

			<template v-slot:form-add-detail>
				<SubcontractRequestDeliveryDetailInput 
					:model="modelSubcontractRequestDeliveryDetail"
					:openPopup="isShowPopupSubcontractRequestDeliveryDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataSubcontractRequestDeliveryDetail"/>
			</template>

			<template v-slot:upload-detail>
					<SubcontractRequestDeliveryDetailUpload
					:openPopup="isShowPopupUploadSubcontractRequestDeliveryDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataSubcontractRequestDeliveryDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentSubcontractRequestDeliveryDetailPage"
				:total-rows="totalSubcontractRequestDeliveryDetailRow"
				:per-page="subcontractRequestDeliveryDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import SubcontractRequestDelivery from '@/models/SubcontractRequestDelivery/SubcontractRequestDelivery';
import SubcontractRequestDeliveryList from '@/models/SubcontractRequestDelivery/SubcontractRequestDeliveryList';
import SubcontractRequestDeliveryFilter from '@/filters/SubcontractRequestDelivery/SubcontractRequestDeliveryFilter';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';
import PurchaseOrderFilter from '@/filters/PurchaseOrder/PurchaseOrderFilter';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextarea from '@/components/AppInputTextarea';
import SubcontractRequestDeliveryDetail from '@/models/SubcontractRequestDelivery/SubcontractRequestDeliveryDetail';
import SubcontractRequestDeliveryDetailFilter from '@/filters/SubcontractRequestDelivery/SubcontractRequestDeliveryDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import SubcontractRequestDeliveryDetailInput from '@/views/SubcontractRequestDelivery/SubcontractRequestDeliveryDetailInput';
import SubcontractRequestDeliveryDetailUpload from '@/views/SubcontractRequestDelivery/SubcontractRequestDeliveryDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextarea,
		AppInputTextbox,
		SubcontractRequestDeliveryDetailInput,SubcontractRequestDeliveryDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsSubcontractRequestDeliveryDetail: [
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"part": { "class" : "th-part first-child", "label" : "Part", key: 'part', sortable: false}}, 
				{"partName": { "class" : "th-part-name", "label" : "Part Name", key: 'partName', sortable: false}}, 
				{"poQtyOutstanding": { "class" : "th-po-qty-outstanding last-child", "label" : "Qty Outstanding PO", key: 'poQtyOutstanding', sortable: false}}, 
				{"stockVendor": { "class" : "th-stock-vendor d-stack-none", "label" : "Stock Vendor", key: 'stockVendor', sortable: false}}, 
				{"deliveryQty": { "class" : "th-delivery-qty d-stack-none", "label" : "Delivery Qty", key: 'deliveryQty', sortable: false}}, 
				{"uom": { "class" : "th-uom d-stack-none", "label" : "Uom", key: 'uom', sortable: false}}, 
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelSubcontractRequestDeliveryDetail : {},
			isShowPopupSubcontractRequestDeliveryDetail : false,
			isShowPopupUploadSubcontractRequestDeliveryDetail : false,
			filterSubcontractRequestDelivery : null,
			currentSubcontractRequestDeliveryPage : 1,
			subcontractRequestDeliveryPageSize: 10,
			sortBySubcontractRequestDelivery: '',
			sortDescSubcontractRequestDelivery: '',
			filterSubcontractRequestDeliveryDetail : null,
			currentSubcontractRequestDeliveryDetailPage : 1,
			subcontractRequestDeliveryDetailPageSize: 10,
			sortBySubcontractRequestDeliveryDetail: '',
			sortDescSubcontractRequestDeliveryDetail: '',
			sortingBySubcontractRequestDeliveryDetail: [],
			subcontractRequestDeliveryDetails : [],
			subcontractRequestDeliveryDetailId : '',
			totalSubcontractRequestDeliveryDetailRow : 0,
			isShowSubcontractRequestDeliveryDetailFilter: false,
			isDownloadSubcontractRequestDeliveryDetail: false,
			parts: [],
			purchaseOrders: [],
			isPurchaseOrderComboLoading: false,
			vendors: [],
			isVendorComboLoading: false,
			documentStatuss: [],
			isDocumentStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isSubcontractRequestDeliveryComboLoading: false,
			isPartComboLoading: false,
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getSubcontractRequestDelivery : async function(id) {
			this.isBusy = true;
			SubcontractRequestDelivery.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadSubcontractRequestDelivery = true;
			this.filterSubcontractRequestDelivery.id = this.modelId;
			SubcontractRequestDelivery.downloadDataDetail(this, this.filterSubcontractRequestDelivery).then(result => {
				this.isDownloadSubcontractRequestDelivery = false;
			}).catch(error => { this.isDownloadSubcontractRequestDelivery = false; })
		},
		getSubcontractRequestDeliveryDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterSubcontractRequestDeliveryDetail);
			if (this.modelId == null) return;
			filter.subcontractRequestDeliveryId = this.modelId;
			filter.draftMode = "1";
			if (this.sortBySubcontractRequestDeliveryDetail != null) {
				this.sortingBySubcontractRequestDeliveryDetail[this.sortBySubcontractRequestDeliveryDetail] = this.sortDescSubcontractRequestDeliveryDetail;
			}
			let currentPage = (this.currentSubcontractRequestDeliveryDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalSubcontractRequestDeliveryDetailRow + 1;
				let page = Math.ceil(totalData/this.subcontractRequestDeliveryDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.subcontractRequestDeliveryDetailPageSize = 0;
			// disable paging end
			SubcontractRequestDeliveryDetail.getList(this, filter, this.sortingBySubcontractRequestDeliveryDetail, currentPage , this.subcontractRequestDeliveryDetailPageSize).then(result => {
				this.currentSubcontractRequestDeliveryDetailPage = currentPage + 1;
				this.subcontractRequestDeliveryDetails = result.data;
				this.totalSubcontractRequestDeliveryDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getSubcontractRequestDeliverys : async function(input) {
			let filter = new SubcontractRequestDeliveryFilter();
			if (input != undefined) {
				filter.RequestDeliveryNumber = input;
			}
			this.isSubcontractRequestDeliveryComboLoading = true;
			SubcontractRequestDelivery.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.subcontractRequestDeliverys = result.data
				}
				this.isSubcontractRequestDeliveryComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		// getPurchaseOrders : async function(input) {
		// 	let filter = new PurchaseOrderFilter();
		// 	if (input != undefined) {
		// 		filter.purchaseOrderNumber = input;
		// 	}
		// 	filter.subcontractRequestDelivery = '1';
		// 	// filter.fwDocStat = '0,1';
		// 	// filter.exactType.fwDocStat = '1';
		// 	PurchaseOrder.getList(this, filter, null, 0, 10)
		// 	.then(result => {
		// 		if (result != null) {
		// 			this.purchaseOrders = result.data
		// 		}
		// 	})
		// 	.catch(error => {});
		// },
		getPurchaseOrders : async function(input) {
			// let filter = new PurchaseOrderFilter();
			// if (input != undefined) {
			// 	filter.purchaseOrderNumber = input;
			// } else(input)
			
			// filter.fwDocStat = '0,1';
			// filter.exactType.fwDocStat = '1';

			// filter.statusId = "APPROVED";
			// filter.poStatus = "OPEN,IN_PROGRESS";

			//Custom Get PurchaseOrders
			let params = '';
			if(input != undefined && input) params = `?poNumber=${input}`;
			// const response = await this.$http.get(`CombineCase/ScanControlCard?id=${id}&qrcode=${qrCode}`);
			const response = await this.$http.get(`SubcontractRequestDelivery/GetPurchaseOrderCustom/${params}`);
			if(response) {
				console.log("response", response);
				this.purchaseOrders = response.data;
			}

			// PurchaseOrder.getList(this, filter, null, 0, 10)
			// .then(result => {
			// 	if (result != null) {
			// 		this.purchaseOrders = result.data
			// 	}
			// })
			// .catch(error => {});
		},
		setSelectedPurchaseOrderExecuted(item) {
			let _this = this;
			if(item == undefined || item == null) {
				this.model.purchaseOrderId = null;
				this.model.purchaseOrder = null;
				this.isBusy = true;
				SubcontractRequestDelivery.resetDocument(this, this.model.id).then(result => {
					this.getSubcontractRequestDelivery(this.model.id).then(result => {
						this.getSubcontractRequestDeliveryDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				this.model.purchaseOrderId = item.id;
				this.model.purchaseOrder = item;

				this.isBusy = true;
				SubcontractRequestDelivery.copyFromDocument(this, 'purchaseorder', item.id, this.model.id).then(result => {
					this.getSubcontractRequestDelivery(this.model.id).then(result => {
						this.getSubcontractRequestDeliveryDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			}
		},
		setSelectedPurchaseOrder(item) {
			if(item) {
				var itemId = Number(item.id);
				if(this.model.purchaseOrderId == itemId) return;
			}

			if(this.subcontractRequestDeliveryDetails != null && this.subcontractRequestDeliveryDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap Subcontract Request Delivery akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.setSelectedPurchaseOrderExecuted(item);
					}
				})
				.catch(err => {})
			} else {
				this.setSelectedPurchaseOrderExecuted(item);
			}
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedVendor(item) {
			if(item == undefined || item == null) {
				this.model.vendorId = null;
				this.model.vendor = null;
			} else {
				this.model.vendorId = item.id;
				this.model.vendor = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.subcontractRequestDeliveryInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					SubcontractRequestDelivery.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'subcontractrequestdeliveryindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					SubcontractRequestDelivery.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'subcontractrequestdeliveryindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					SubcontractRequestDelivery.updateData(this, model, id)
					.catch((error) => {
						this.getSubcontractRequestDelivery(id);
					});
				}
			});
		},
		onHidden() {
			this.getSubcontractRequestDeliverys();
		},
		addRowDataSubcontractRequestDeliveryDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.subcontractRequestDeliveryId =  this.modelId;
					SubcontractRequestDeliveryDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getSubcontractRequestDeliveryDetails(true);
						this.isShowPopupSubcontractRequestDeliveryDetail = false;
					})
				} else {
					model.subcontractRequestDeliveryId =  this.modelId;
					SubcontractRequestDeliveryDetail.createDataDetail(this, model)
					.then(result => {
						this.getSubcontractRequestDeliveryDetails(true);
						this.isShowPopupSubcontractRequestDeliveryDetail = false;
					})
				}
			}
		},
		async editRowDataSubcontractRequestDeliveryDetail(id) {
			this.subcontractRequestDeliveryDetailId = id;
			this.isShowPopupSubcontractRequestDeliveryDetail = true; 
		},
		async deleteRowDataSubcontractRequestDeliveryDetail(id) {
			SubcontractRequestDeliveryDetail.deleteData(this, id).then(result => { this.getSubcontractRequestDeliveryDetails(); });
		},
		async resetDataSubcontractRequestDeliveryDetail() {
			this.subcontractRequestDeliveryDetailId = "";
			this.isShowPopupSubcontractRequestDeliveryDetail = true;
		},
		async addDataSubcontractRequestDeliveryDetail() {
			SubcontractRequestDeliveryDetail.createData(this, { subcontractRequestDeliveryId: this.modelId })
			.then(result => {
				this.getSubcontractRequestDeliveryDetails(true);
			})
		},
		async addFromClipboardSubcontractRequestDeliveryDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, subcontractRequestDeliveryId: this.modelId });
				});
				SubcontractRequestDeliveryDetail.addFromClipboard(this, parts).then(result => { this.getSubcontractRequestDeliveryDetails() });
			});
		},
		async replaceFromClipboardSubcontractRequestDeliveryDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, subcontractRequestDeliveryId: this.modelId });
				});
				SubcontractRequestDeliveryDetail.replaceFromClipboard(this, parts).then(result => { this.getSubcontractRequestDeliveryDetails() });
			});   
		},
		showPopupUploadSubcontractRequestDeliveryDetail() {
			if(this.subcontractRequestDeliveryDetails != null && this.subcontractRequestDeliveryDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap SubcontractRequestDeliveryDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadSubcontractRequestDeliveryDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadSubcontractRequestDeliveryDetail = true;
			}
		},
		uploadDataSubcontractRequestDeliveryDetail(modalEvent, newDatas) {
			this.isShowPopupUploadSubcontractRequestDeliveryDetail = false; 
		},
		downloadSubcontractRequestDeliveryDetail(modalEvent) {
			this.isDownloadSubcontractRequestDeliveryDetail = true;
			this.filterSubcontractRequestDeliveryDetail.subcontractRequestDeliveryId = this.modelId;
			SubcontractRequestDeliveryDetail.downloadDataDetail(this, this.filterSubcontractRequestDeliveryDetail).then(result => {
				this.isDownloadSubcontractRequestDeliveryDetail = false;
			}).catch(error => { this.isDownloadSubcontractRequestDeliveryDetail = false; })
		},
		saveInputSubcontractRequestDeliveryDetail(item) {
			if (this.subcontractRequestDeliverys != null && this.subcontractRequestDeliverys != undefined  && this.subcontractRequestDeliverys.length > 0) {
				item.subcontractRequestDelivery = this.subcontractRequestDeliverys.find(q => q.id == item.subcontractRequestDeliveryId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					SubcontractRequestDeliveryDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadSubcontractRequestDeliveryDetail = false; 
			this.isShowPopupSubcontractRequestDeliveryDetail = false; 
			if (modalType == 'SubcontractRequestDeliveryDetail') {
				this.getSubcontractRequestDeliveryDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowSubcontractRequestDeliveryDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterSubcontractRequestDelivery = new SubcontractRequestDeliveryFilter();
		this.filterSubcontractRequestDeliveryDetail = new SubcontractRequestDeliveryDetailFilter();
		//this.getSubcontractRequestDeliverys();
		//this.getParts();
		//this.getPurchaseOrders();
		//this.getVendors();
		//this.getDocumentStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getSubcontractRequestDelivery(id);
			} else {
				this.modelId = id;
				this.getSubcontractRequestDelivery(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
		sortBySubcontractRequestDeliveryDetail : {
			handler: function() {
				this.getSubcontractRequestDeliveryDetails();
			}
		},
		sortDescSubcontractRequestDeliveryDetail: {
			handler: function() {
				this.getSubcontractRequestDeliveryDetails();
			}
		},
		currentSubcontractRequestDeliveryDetailPage: {
			handler: function() {
				this.getSubcontractRequestDeliveryDetails();
			}
		},
		subcontractRequestDeliveryDetailPageSize : {
			handler: function() {
				this.getSubcontractRequestDeliveryDetails();
			}
		},
		filterSubcontractRequestDeliveryDetail: {
			handler: function() {
				this.getSubcontractRequestDeliveryDetails();
			},
			deep: true,
		},
	},
}
</script>
